import { render, staticRenderFns } from "./BrandAdmin.vue?vue&type=template&id=3a5ce72a&"
import script from "./BrandAdmin.vue?vue&type=script&lang=js&"
export * from "./BrandAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports